module.exports = __webpack_public_path__ + "static/media/header-about-bg.6db5f51f.png";